<template>
  <div :class="isMobile && joined ? 'joined' : ''" class="menu">
    <el-row :gutter="16" class="mobile-home-cards" v-if="isMobile && !joined">
      <el-col :span="8" class="mobile-home-card">
        <div @click="openDiscover">
          <CompassIcon/>
          <label>discover</label>
        </div>
      </el-col>
      <el-col :span="8" class="mobile-home-card">
        <div>
          <CalendarIcon/>
          <label>Upcoming</label>
        </div>
      </el-col>
      <el-col :span="8" class="mobile-home-card">
        <div @click='openWorkouts'>
          <ZapIcon/>
          <label>workouts</label>
        </div>
      </el-col>
      <el-col v-if="isTrainer" :span="24" class="mobile-home-card">
        <div>
          <ClockIcon/>
          <label>my scheduled workouts</label>
        </div>
      </el-col>
    </el-row>

    <el-popover v-if="!isMobile" placement="bottom" width="300" v-model="upcomingWOsVisible">
      <el-button slot="reference" type="default" size="small" round icon="el-icon-date">Registered workouts</el-button>
      <label>registered workouts</label>
      <hr>
      <div class="upcoming-events">
        <label>10/4/2021</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Today's best HIIT</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
      <div class="upcoming-events">
        <label>12/10/2021</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Chest 101</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
      <div class="upcoming-events">
        <label>1/28/2022</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Booty Burner 3000</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
    </el-popover>
    <el-popover v-if="isTrainer && !isMobile" placement="bottom" width="300" v-model="myScheduleVisible">
      <el-button slot="reference" type="default" size="small" round icon="el-icon-time">Scheduled workouts</el-button>
      <label>scheduled workouts</label>
      <hr>
      <div class="upcoming-events">
        <label>10/4/2021</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Today's best HIIT</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
      <div class="upcoming-events">
        <label>12/10/2021</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Chest 101</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
      <div class="upcoming-events">
        <label>1/28/2022</label>
        <el-card shadow="never">
          <div slot="header">
            <b>Booty Burner 3000</b>
            <el-button size="mini" type="primary" plain round>Join <i class="el-icon-right"></i></el-button>
          </div>
          <div>6:00 AM America/New York</div>
        </el-card>
      </div>
    </el-popover>
    <el-button v-if="!isMobile" @click="openDiscover" type="default" size="small" round :icon="isMobile ? 'el-icon-menu' : 'el-icon-discover'">Discover</el-button>
    <el-dropdown :class="isMobile && 'mobile-menu-btn'" trigger="click">
      <el-button @click='updateUser' :type="isMobile ? 'text' : 'default'" size="small" :icon="isMobile ? '' : 'el-icon-house'" circle><MenuIcon v-if="isMobile"/></el-button>
      <el-dropdown-menu class="menu-dropdown">
        <el-dropdown-item v-if="isTrainer" icon="el-icon-star-off" class="is-trainer" style="pointer-events: none"><label>Trainer</label></el-dropdown-item>
        <el-dropdown-item style="pointer-events: none">{{ username }}</el-dropdown-item>
        <el-link v-if="!isMobile" @click='openWorkouts'>
          <el-dropdown-item icon="el-icon-menu" divided>
            Workouts
          </el-dropdown-item>
        </el-link>
        <el-link @click='openSettings'>
          <el-dropdown-item icon="el-icon-setting" :divided='isMobile ? true : false'>
            Settings
          </el-dropdown-item>
        </el-link>
        <el-link @click='Logout'>
          <el-dropdown-item class="logout-btn" icon="el-icon-lock" divided>
            Logout
          </el-dropdown-item>
        </el-link>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import firebase from 'firebase'
import { CompassIcon, ZapIcon, CalendarIcon, ClockIcon, MenuIcon } from 'vue-feather-icons'

export default {
  data() {
    return {
      username: localStorage.username,
      isTrainer: '',
      myScheduleVisible: false,
      upcomingWOsVisible: false,
      mobileMenu: '',
      isMobile: ''
    }
  },
  props: {
    joined: Boolean
  },
  components: {
    CompassIcon,
    ZapIcon,
    CalendarIcon,
    ClockIcon,
    MenuIcon
  },
  methods: {
    openSettings() {
      this.$emit('settingsTrigger')
    },
    openWorkouts() {
      this.$emit('workoutsTrigger')
    },
    openDiscover() {
      this.$emit('discoTrigger')
    },
    updateUser() {
      this.username = localStorage.username
    },
    Logout() {
      this.$emit('logoutTrigger')
      this.$nextTick(() => {
        firebase.auth().signOut().then(() => console.log('logged out')).catch(err => alert(err.message))
      })
    }
  },
  created() {
    let uid = JSON.parse(localStorage.getItem('user')).uid
    firebase.database().ref().child(uid).child('isTrainer').get().then(snapshot => this.isTrainer = snapshot.val())

    // ****** isMobile
    // Define our viewportWidth variable
    let viewportWidth
    // Set/update the viewportWidth value
    let setViewportWidth = () => {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth
    }
    // Log the viewport width into the console
    let logWidth = () => {
      if (viewportWidth > 991) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
    // Set our initial width and log it
    setViewportWidth()
    logWidth()
    // On resize events, recalculate and log
    window.addEventListener('resize', () => {
      setViewportWidth()
      logWidth()
    }, false)
  }
}
</script>


<style>
.menu {
  display: flex;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 2;
}

.menu .el-button {
  border-color: #fff;
  margin-left: 8px;
}

.menu .el-button:focus,
.menu .el-button:hover {
  border-color: #DCDFE6
}

.menu .el-button:active {
  border-color: #3a8ee6;
}

.menu-dropdown .is-trainer {
  color: #e020aa;
}

.menu-dropdown .is-trainer label {
  display: inline-block;
  margin: 0;
}

.menu-dropdown .el-link.el-link--default {
  display: flex;
}

.menu-dropdown .el-link.el-link--default .el-link--inner {
  width: 100%;
}

.menu-dropdown .el-link.el-link--default .el-link--inner .el-dropdown-menu__item {
  width: 100%;
}

.el-dropdown-menu__item.logout-btn {
  color: #F56C6C;
}

.upcoming-events label {
  margin-top: 16px;
}

.upcoming-events .el-card {
  background-color: #EBEEF5;
  border: 0;
  margin-top: 8px;
}

.upcoming-events .el-card__header,
.upcoming-events .el-card__body {
  border-color: #fff;
  border-width: 2px;
  padding: 8px 16px;
}

.upcoming-events .el-card__header > div {
  align-items: center;
  display: flex;
}

.upcoming-events .el-card__header .el-button {
  margin-left: auto;
}

/******************************
*
*
* MOBILE STYLES
*
*
******************************/

@media (max-width: 991px) {
  .menu-dropdown {
    border: 0;
    border-radius: 0 0 32px 32px;
    box-shadow: none;
    left: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    padding: 12px 0;
    top: 0 !important;
    width: 100%;
  }

  .menu-dropdown .popper__arrow {
    display: none;
  }

  .menu-dropdown::before {
    animation: bg-transition .5s forwards;
    content: '';
    height: 100%;
    pointer-events: none;
    position: fixed !important;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  @-webkit-keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }
  @-moz-keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }
  @keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }

  .menu-dropdown::after {
    background: #fff;
    border-radius: 0 0 32px 32px;
    content: '';
    height: 100%;
    position: absolute !important;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  .menu {
    bottom: 24px;
    height: calc(100% - 48px);
    right: 8px;
    width: calc(100% - 32px);
  }

  .menu.joined {
    height: 29px;
    width: 50px
  }

  .menu .mobile-menu-btn {
    color: #fff;
    position: absolute;
    right: 16px;
    top: 0;
  }

  .menu .mobile-menu-btn .el-button {
    border: 0;
    margin: 0;
    padding: 0;
  }

  .menu .mobile-menu-btn svg {
    color: #fff;
    stroke-width: 2px;
  }
  
  .menu .mobile-home-cards {
    width: 100%;
    margin-top: auto;
  }

  .menu .mobile-home-cards .mobile-home-card:nth-child(4) {
    margin-top: 16px;
  }

  .menu .mobile-home-cards .mobile-home-card div {
    background-color: rgba(255, 255, 255, .75);
    background: linear-gradient(90deg, #fff, rgba(255, 255, 255, .75));
    border-radius: 16px;
    /* border: 2px solid #fff; */
    box-shadow: 3px 3px 5px rgba(0, 0, 0, .16);
    color: #2c3e50;
    cursor: pointer;
    padding: 12px 8px 8px;
    text-align: center;
    transition: .15s;
  }

  .menu .mobile-home-cards .mobile-home-card div:hover {
    background-color: #fff;
  }

  .menu .mobile-home-cards .mobile-home-card div label  {
    margin-top: 8px;
  }
}

@media (max-width: 374px) {
  .menu .mobile-home-cards .mobile-home-card div label {
    font-size: 10px;
  }
}
</style>